document.addEventListener('DOMContentLoaded', () => {
  const lightbox = document.getElementById('simpleLightbox');
  if (!lightbox) return;

  const lightboxImage = lightbox.querySelector('.simple-lightbox__image');
  const closeButton = lightbox.querySelector('.simple-lightbox__close');
  const backdrop = lightbox.querySelector('.simple-lightbox__backdrop');
  const prevButton = lightbox.querySelector('.simple-lightbox__prev');
  const nextButton = lightbox.querySelector('.simple-lightbox__next');
  const triggers = Array.from(document.querySelectorAll('.js-lightbox'));

  let currentGallery = [];
  let currentIndex = 0;

  const openLightboxByIndex = (index) => {
    if (!currentGallery.length) return;

    currentIndex = index;

    const trigger = currentGallery[currentIndex];
    const img = trigger.querySelector('img');
    const src = trigger.getAttribute('href');
    const alt = img ? img.getAttribute('alt') || '' : '';

    lightboxImage.src = src;
    lightboxImage.alt = alt;
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    lightboxImage.src = '';
    lightboxImage.alt = '';
    document.body.style.overflow = '';
  };

  const showNext = () => {
    if (!currentGallery.length) return;
    currentIndex = (currentIndex + 1) % currentGallery.length;
    openLightboxByIndex(currentIndex);
  };

  const showPrev = () => {
    if (!currentGallery.length) return;
    currentIndex = (currentIndex - 1 + currentGallery.length) % currentGallery.length;
    openLightboxByIndex(currentIndex);
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();

      const galleryName = trigger.dataset.gallery || 'default';

      currentGallery = triggers.filter((item) => {
        return (item.dataset.gallery || 'default') === galleryName;
      });

      currentIndex = currentGallery.indexOf(trigger);

      openLightboxByIndex(currentIndex);
    });
  });

  if (closeButton) {
    closeButton.addEventListener('click', closeLightbox);
  }

  if (backdrop) {
    backdrop.addEventListener('click', closeLightbox);
  }

  if (nextButton) {
    nextButton.addEventListener('click', showNext);
  }

  if (prevButton) {
    prevButton.addEventListener('click', showPrev);
  }

  document.addEventListener('keydown', (event) => {
    if (!lightbox.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      closeLightbox();
    }

    if (event.key === 'ArrowRight') {
      showNext();
    }

    if (event.key === 'ArrowLeft') {
      showPrev();
    }
  });
});